<template>
  <div
    :class="$style.root"
  >
    <LayoutPageHeaderComponent
      :data="localizedData"
      :class="$style.header"
    >
      {{ subtitle }}
    </LayoutPageHeaderComponent>

    <swiper
      :slidesPerView="'auto'"
      :class="$style.swiper"
      :centered-slides="true"
      @swiper="onSwiper"
    >
      <SwiperSlide
        v-for="(block, index) in localizedData?.images"
        :key="index"
        :class="$style.slide"
      >
        <CoreImageComponent
          :image="block?.image?.data?.attributes"
          :class="$style.image"
          :includeCaption="false"
          @click="swiperInstance?.slideNext()"
        />

        <CoreTextComponent
          v-if="getDescription(block?.descriptions)"
          :string="getDescription(block?.descriptions)"
          :class="$style.caption"
        />
      </SwiperSlide>
    </swiper>

    <nav :class="$style.nav">
      <button
        @click="swiperInstance?.slidePrev()"
        data-outline
        :class="$style.button"
        dir="prev"
      >
        <SvgoArrow />
      </button>

      <button
        @click="swiperInstance?.slideNext()"
        data-outline
        :class="$style.button"
        dir="next"
      >
        <SvgoArrow />
      </button>
    </nav>

    <CoreBlocksComponent
      v-if="localizedData.blocks"
      :blocks="localizedData.blocks"
    />
  </div>
</template>

<script setup>
import 'swiper/css'
import { Swiper, SwiperSlide } from 'swiper/vue'

const props = defineProps({
  pageData: Object
})

const localizedData = computed(() => {
  return i18nGetLocalizedData(baseStrapiGetAttributes(props?.pageData?.data))
})

const subtitle = computed(() => i18nGetLocalizedString(localizedData?.value?.subtitles))

const getDescription = (data) => i18nGetLocalizedString(data)

const swiperInstance = ref(null)
const onSwiper = (swiper) => {
  swiperInstance.value = swiper
}
</script>

<style module>
.root {
  position: relative;

  display: flex;
  flex-direction: column;
  gap: calc(var(--unit--vertical) * 3);
}

.header {
  padding-bottom: 0;
}

.swiper {
  max-width: 100vw;

}

.slide {
  width: auto;
  padding: 0 calc(var(--unit--horizontal) / 2);
}

.image {
  --base--image--height: calc(var(--100svh, 100vh) * .65);
  max-width: calc(100vw - var(--unit--horizontal) * 2);
}

.caption {
  composes: font-size-small from global;
  max-width: min(40rem, calc(100vw - var(--unit--horizontal) * 2));

  opacity: 0;
  height: 0;

  font-size: .95rem;
  line-height: 1.35rem;

  text-align: center;

  margin-top: var(--unit--vertical);
  margin-left: auto;
  margin-right: auto;
}

.slide[class*='active'] .caption {
  opacity: 1;
  height: auto;
}

.nav {
  composes: container--default from global;
  display: flex;
  justify-content: flex-end;
  gap: var(--unit--spacer);
}

.button {
  composes: reset-button button-square from global;
}

.button[dir="next"] {
  transform: rotate(180deg);
}
</style>
